import { Injectable, inject, OnDestroy } from '@angular/core';
import { NgIdleModule, DEFAULT_INTERRUPTSOURCES, Idle,IdleExpiry, SimpleExpiry  } from '@ng-idle/core';
import { Store } from '@ngrx/store';
import { catchError, filter, of, Subject, takeUntil } from 'rxjs';
import { IdleActions } from '@store/actions/idle/idle.actions';
import { IdleTime, Timeout } from '@store/selectors/idle/idle.selectors';

@Injectable({
  providedIn: 'root'
})
export class IdleService implements OnDestroy {

  private readonly store = inject(Store);
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private idle: Idle,
  ) {

    this.idle.setIdle(IdleTime);
    this.idle.setTimeout(Timeout);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.pipe(
        takeUntil(this._destroying$)
    ).subscribe(() => {
      this.store.dispatch(IdleActions.idleStart());
    });

    this.idle.onTimeout.pipe(
        takeUntil(this._destroying$)
    ).subscribe(() => {
      this.store.dispatch(IdleActions.timedOut());
    });

    this.idle.onIdleEnd.pipe(
        takeUntil(this._destroying$)
    ).subscribe(() => {
      this.store.dispatch(IdleActions.idleEnd());

    });

    this.idle.onTimeoutWarning.pipe(
        takeUntil(this._destroying$)
    ).subscribe((countdown) => {
      this.store.dispatch(IdleActions.timeOutWarning())
    });

  }

  startIdleWatch(): void {
   this.idle.watch();
  }


  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.idle.stop();
  }
}
